import slice from 'modules/a11ycat/slice';

export const {setTitle, setSendSnapshot, setScriptLoaded} = slice.actions;
